import { EMPTY_CHARGE_HEADER_MAINTENANCE_MODEL } from 'presentation/model/ChargeHeaderMaintenance/ChargeHeaderMaintenanceModel';
import { useState } from 'react';
import {createContainer} from "react-tracked";

const {
    Provider: ChargeHeaderMaintenanceProvider,
    useTracked: useChargeHeaderMaintenanceTracked
} = createContainer(() => useState(EMPTY_CHARGE_HEADER_MAINTENANCE_MODEL), {concurrentMode: true});
export {ChargeHeaderMaintenanceProvider, useChargeHeaderMaintenanceTracked};